import { render, staticRenderFns } from "./SearchAlike.vue?vue&type=template&id=04f5101a&scoped=true&"
import script from "./SearchAlike.vue?vue&type=script&lang=js&"
export * from "./SearchAlike.vue?vue&type=script&lang=js&"
import style0 from "./SearchAlike.vue?vue&type=style&index=0&id=04f5101a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f5101a",
  null
  
)

export default component.exports